import { supportedCurrencies } from '@/wabunka-src/common/utils/currency';
import { captureException } from '@/wabunka-src/common/utils/sentry';
import { useCookie } from '#composables/nuxt';

export const useCurrency = () => {
  const currencyCookie = useCookie<string>('wabunka_currency', {
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
    path: '/',
  });

  const selectedCurrency = computed({
    get: () => {
      const value = currencyCookie.value;
      if (value && supportedCurrencies.some((c) => c.code === value)) {
        return value;
      }
      return 'JPY';
    },
    set: (value: string) => {
      const isValidCurrency = supportedCurrencies.some((c) => c.code === value);
      if (!isValidCurrency) {
        captureException(new Error(`Invalid currency code: ${value}`), 'wabunka');
        return;
      }
      currencyCookie.value = value;
    },
  });

  return {
    selectedCurrency,
    supportedCurrencies,
  };
};
